import { inject, Injectable } from '@angular/core';
import { lastValueFrom, ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { AuthService } from '../auth';

import { UserSecurityFactory } from 'app/factories';

@Injectable()
export class NewUserService {
    private userSecurityFactory = inject(UserSecurityFactory);
    private authService = inject(AuthService);
    async deleteUserAccount(): Promise<void> {
        const subject = new ReplaySubject(1);

        const response = await lastValueFrom(this.userSecurityFactory.deleteUserAccount().pipe(first()));

        if (response?.success) {
            await new Promise<void>((resolve, reject) => {
                this.authService.onLogoutSuccess(true, subject);

                subject.subscribe({
                    next: () => resolve(),
                    error: (err) => reject(err),
                    complete: () => resolve(),
                });
            });
        }
    }
}
